import { FaEdit } from "react-icons/fa";
import { SecondaryButton } from "../../../UI/DesignStandards";

const PrizeFundDistributionHeader = ({
  totalPrizeFund,
  totalAssigned,
  isRefreshing,
  isPayoutFinalized,
  canManage,
  editMode,
  isSubmitting,
  onEditDistribution,
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
      <div className="text-center sm:text-left">
        <h2 className="heading-display text-xl">
          Additional Prize Fund Distribution
        </h2>
        <div className="mt-2 flex flex-wrap gap-4 text-sm text-brand-muted">
          <span className="flex items-center gap-1">
            <span className="font-medium">Available:</span>
            <span className="font-score font-semibold text-brand-charcoal">
              ${totalPrizeFund.toFixed(2)}
            </span>
            {isRefreshing && (
              <div className="inline-flex items-center ml-2">
                <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-brand-gold-ink"></div>
              </div>
            )}
          </span>
          <span className="flex items-center gap-1">
            <span className="font-medium">Assigned:</span>
            <span className="font-score font-semibold text-brand-charcoal">
              ${totalAssigned.toFixed(2)}
            </span>
          </span>
          <span className="flex items-center gap-1">
            <span className="font-medium">Remaining:</span>
            <span className="font-score font-semibold text-brand-charcoal">
              ${(totalPrizeFund - totalAssigned).toFixed(2)}
            </span>
          </span>
          {isSubmitting && (
            <span className="flex items-center gap-1 text-brand-muted">
              <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-brand-gold-ink"></div>
              <span className="font-medium">Saving...</span>
            </span>
          )}
        </div>
        {isPayoutFinalized && (
          <div className="mt-3 card-inset p-3">
            <p className="text-sm text-brand-muted">
              Payouts have been locked. Prize fund distribution cannot be
              modified.
            </p>
          </div>
        )}
      </div>
      {canManage && (
        <div className="flex justify-center sm:justify-end">
          {!editMode && (
            <SecondaryButton
              onClick={onEditDistribution}
              disabled={isPayoutFinalized || isSubmitting}
              className={
                isPayoutFinalized || isSubmitting
                  ? "opacity-50 cursor-not-allowed !px-3 !py-2 text-sm"
                  : "!px-3 !py-2 text-sm"
              }
              title={
                isPayoutFinalized
                  ? "Payouts have been locked and cannot be changed"
                  : isSubmitting
                  ? "Please wait while changes are being saved"
                  : "Edit prize fund distribution"
              }
            >
              <FaEdit className="mr-2" />
              Edit Distribution
            </SecondaryButton>
          )}
        </div>
      )}
    </div>
  );
};

export default PrizeFundDistributionHeader;
